import * as d3 from "d3";
import { ChartObjects, ChartSVG, ChartDimensions, ChartScale, ChartAxesV2 } from '../chart-basics/module';
import { getParameter } from '../d3-services/_helpers';
import { HtmlHeader, HtmlPopupV2, HtmlSegment } from '../html-elements/module';
var GraphControllerV2 = /** @class */ (function () {
    function GraphControllerV2(main, data, element, mapping, segment) {
        this.main = main;
        this.data = data;
        this.element = element;
        this.mapping = mapping;
        this.segment = segment;
        this.element = d3.select(element).node();
        this.firstMapping = this.mapping.parameters[0] && this.mapping.parameters[0][0] ? getParameter(this.mapping, 0) : false;
        this.parameters = {};
        this.scales = {};
        this.axes = {};
        this.config = { margin: { top: 0, bottom: 0, left: 0, right: 0 }, padding: { top: 0, bottom: 0, left: 0, right: 0 }, scales: [], axes: [], extra: {} };
    }
    GraphControllerV2.prototype._init = function () {
        var self = this;
        // get parameters from mapping
        for (var _i = 0, _a = this.mapping.parameters; _i < _a.length; _i++) {
            var p = _a[_i];
            for (var _b = 0, _c = p.filter(function (p) { return p.scale !== null; }); _b < _c.length; _b++) {
                var m = _c[_b];
                this.parameters[m.scale] = m.column;
            }
        }
        // add .. overrule from config.scales
        for (var _d = 0, _e = this.config.scales.filter(function (s) { return s.parameter && s.parameter != null; }); _d < _e.length; _d++) {
            var s = _e[_d];
            this.parameters[s.slug] = s.parameter;
        }
        if (this.mapping.description && this.mapping.description !== '') {
            this.popup = new HtmlPopupV2(this.element, this.mapping.description);
        }
        this.htmlSegment = new HtmlSegment(this.element);
        if (this.mapping.header) {
            this.htmlHeader = new HtmlHeader(this.element, this.mapping.header != undefined ? this.mapping.header : this.firstMapping['label']);
            this.htmlHeader.draw();
        }
        var chartObjects = ChartObjects();
        this.config = Object.assign(chartObjects.config(), this.config);
        this.dimensions = chartObjects.dimensions();
        this.svg = chartObjects.svg();
    };
    GraphControllerV2.prototype._svg = function (svgWrapper) {
        // with elementID we can create a child element as svg container with a fixed height. 
        this.element = d3.select(svgWrapper ? svgWrapper : this.element).node();
        this.chartDimensions = new ChartDimensions(this.element, this.config);
        this.dimensions = this.chartDimensions.measure(this.dimensions);
        this.chartSVG = new ChartSVG(this.element, this.config, this.dimensions, this.svg);
        for (var _i = 0, _a = this.config.scales; _i < _a.length; _i++) {
            var c = _a[_i];
            this.scales[c.slug] = new ChartScale(this, c);
        }
        for (var _b = 0, _c = this.config.axes; _b < _c.length; _b++) {
            var c = _c[_b];
            this.axes[c.slug] = new ChartAxesV2(this, c);
        }
    };
    GraphControllerV2.prototype.redraw = function (data) {
        if (this.svg && this.svg.body == undefined)
            return;
        this.dimensions = this.chartDimensions.measure(this.dimensions);
        this.chartSVG.redraw(this.dimensions);
        if (this.config.scales) {
            for (var _i = 0, _a = this.config.scales; _i < _a.length; _i++) {
                var c = _a[_i];
                this.scales[c.slug].reset();
            }
        }
        for (var _b = 0, _c = this.config.axes; _b < _c.length; _b++) {
            var a = _c[_b];
            this.axes[a.slug].redraw(this.dimensions, this.scales[a.scale].scale, data.slice);
        }
    };
    GraphControllerV2.prototype.draw = function (data) {
    };
    GraphControllerV2.prototype.prepareData = function (data) {
    };
    GraphControllerV2.prototype._update = function (newData, segment, update) {
        var self = this;
        if (update && this.config.extra.noUpdate) {
            return;
        }
        if (this.mapping.description) {
            this.popup.attachData(newData);
        }
        var data = self.prepareData(newData);
        self.draw(data);
        self.redraw(data);
        window.addEventListener("resize", function () { return self.redraw(data); }, false);
        if (this.mapping.segmentIndicator) {
            this.htmlSegment.draw(segment);
        }
    };
    GraphControllerV2.prototype._addScale = function (slug, type, direction, parameter) {
        this.config.scales.push({
            slug: slug,
            type: type,
            direction: direction,
            parameter: parameter
        });
    };
    GraphControllerV2.prototype._addAxis = function (slug, scale, position, format, extra, label) {
        this.config.axes.push({
            slug: slug,
            scale: scale,
            position: position,
            format: format,
            extra: extra,
            label: label
        });
    };
    GraphControllerV2.prototype._addMargin = function (top, bottom, left, right) {
        this.config.margin = {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };
    GraphControllerV2.prototype._addPadding = function (top, bottom, left, right) {
        this.config.padding = {
            top: top,
            bottom: bottom,
            left: left,
            right: right
        };
    };
    return GraphControllerV2;
}());
export { GraphControllerV2 };
